import React, { useEffect, useState } from 'react';
import icons from '../../../icons';
import style from './OptionSelection.module.css';

import { useContext } from 'react';
import Banner from '../../Banner/Banner';
import TextButton from '../../Buttons/TextButton/TextButton';
import { AppContext } from '../../../AppContext';


const OptionSelection = props => {
    const { setPage, subjects, timetable, user, users } = useContext(AppContext);
    
    const [link, setLink] = useState("");
    const [linkText, setLinkText] = useState("");

    return <main className={ style.main } style={{ height: props.option && "100vh" }}>
        { (() => {
            switch (props.option) {
                case "link":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2>Aggiungi un <span style={{ color: "var(--orange)" }}>link</span></h2>
                            </div>
                            <Banner />
                        </section>
                        <div className={ style.loginItem }>
                            <img alt="" src={ link.includes("instagram") ? icons.instagram_orange_icon : icons.globe_icon } />
                            <input className={ style.link } placeholder="Link" pattern="https://.*" type="url" value={ link } onChange={ e => setLink(e.target.value) }></input>
                        </div>
                        <div className={ style.loginItem } style={{ marginTop: "0" }}>
                            <img alt="" src={ icons.test_icon } />
                            <input className={ style.link } placeholder="Testo del link" type="text" value={ linkText } onChange={ e => setLinkText(e.target.value) }></input>
                        </div>
                        <TextButton text="SALVA" style={{ width: "60vw", marginLeft: "auto", marginRight: "auto", marginTop: "2rem" }} onClick={ () => {
                            if (!link.includes("https://")) {
                                props.setError({ show: true, error: "Inserisci un link valido! (del tipo: \"https://\")" })
                                props.select({ link: "", linkText });
                                return;
                            }

                            props.select({ link, linkText });
                            props.back();
                        } } />
                    </>;
            }
        })() }
    </main>
};

export default OptionSelection;
